import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCommentNoteEntry } from '../../../api/Property/createCommentNoteEntry';

type CreateCommentNoteEntryProps = {
  property_id: string;
  comment_id: string;
  body: string;
}

export function useCreateCommentNoteEntry() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ property_id, comment_id, body }: CreateCommentNoteEntryProps) =>
      createCommentNoteEntry(property_id, comment_id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ 'getComments' ] });
    },
  });

  return mutation;
}
